import React, { useState } from "react";
import Swal from "sweetalert2";

export const AlertContext = React.createContext([]);

export const AlertContextProvider = ({ children }) => {
  const [tabAudit, settabAudit] = useState({ personal: 0, company: 0 });
  const [tabAnalyze, settabAnalyze] = useState(null);

  const [folderAudit, setfolderAudit] = useState(null);
  const [toogleHelp, settoogleHelp] = useState(false);
  //functions
  const showErrors = (errors) => {
    Swal.fire({
      icon: "warning",
      html: getError(errors),
    });
  };
  function redirectPaymentInspection() {
    alert("aas");
  }
  const getError = (errors) => {
    let keys = Object.keys(errors);
    let li = "";

    for (let i = 0; i < keys.length; i++) {
      li = li + "<li>" + eval("errors." + keys[i]) + "</li>";
    }
    return li;
  };
  const alertSuccess = (text) => {
    const Toast = Swal.mixin({
      toast: true,
      background: "#ffffff",
      position: "bottom-end",
      showConfirmButton: false,
      timer: 4000,
    });

    Toast.fire({
      icon: "success",
      title: text,
    });
  };
  const alertInfo = (text) => {
    const Toast = Swal.mixin({
      toast: true,
      background: "#ffffff",
      position: "bottom-end",
      showConfirmButton: false,
      timer: 4000,
    });

    Toast.fire({
      icon: "info",
      title: text,
    });
  };
  const alertWarning = (text) => {
    const Toast = Swal.mixin({
      toast: true,
      background: "#e4e4e4",
      position: "bottom-end",
      showConfirmButton: false,
      timer: 4000,
    });

    Toast.fire({
      icon: "warning",
      title: text,
    });
  };
  const alertError = (text) => {
    const Toast = Swal.mixin({
      toast: true,
      background: "#e4e4e4",
      position: "bottom-end",
      showConfirmButton: false,
      timer: 4000,
    });

    Toast.fire({
      icon: "error",
      title: text,
    });
  };

  return (
    <AlertContext.Provider
      value={[
        { folderAudit, tabAudit, toogleHelp, tabAnalyze },
        {
          setfolderAudit,
          settoogleHelp,
          settabAudit,
          alertInfo,
          alertSuccess,
          alertWarning,
          alertError,
          showErrors,
          settabAnalyze,
        },
      ]}
    >
      {children}
    </AlertContext.Provider>
  );
};
